import { motion } from "framer-motion";
import { Award } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const AWARDS = [
    { year: "2025", title: "Developer of the Year, South", by: "Realty+ Excellence" },
    { year: "2024", title: "Sustainable Design · Platinum", by: "IGBC" },
    { year: "2024", title: "Best Luxury Residence — West", by: "Architectural Digest India" },
    { year: "2023", title: "Iconic Boutique Developer", by: "CREDAI National" },
    { year: "2023", title: "Commercial Project of the Year", by: "Economic Times Realty" },
    { year: "2022", title: "Design Excellence — Landscape", by: "Elle Decor" },
];

const PRESS = [
    "Architectural Digest India",
    "Elle Decor",
    "Design Anthology",
    "The Hindu",
    "Economic Times",
    "Livemint",
    "Vogue Living",
    "House & Garden",
];

export default function AwardsMedia() {
    return (
        <section
            data-testid="awards-media-section"
            className="relative bg-forest-950 text-ivory py-24 md:py-40 border-t border-white/10"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 mb-14 md:mb-20 items-end">
                    <div className="md:col-span-7">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="h-px w-10 bg-lime" />
                            <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">
                                Awards · Press · Recognition
                            </span>
                        </div>
                        <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-[15ch]">
                            Quietly recognised, occasionally.
                        </h2>
                    </div>
                    <div className="md:col-span-4 md:col-start-9 text-ivory/70 leading-relaxed">
                        We do not enter every competition, and we do not pitch every publication.
                        But when the work speaks, editors and juries have often written back.
                    </div>
                </div>

                <ul className="divide-y divide-white/10 border-y border-white/10">
                    {AWARDS.map((a, i) => (
                        <motion.li
                            key={i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-10% 0px" }}
                            transition={{ duration: 0.85, ease: EASE, delay: (i % 3) * 0.05 }}
                            data-testid={`award-row-${i}`}
                            className="grid grid-cols-12 items-center py-6 md:py-8 gap-4 md:gap-6 group"
                        >
                            <div className="col-span-3 md:col-span-1 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime">
                                {a.year}
                            </div>
                            <div className="col-span-9 md:col-span-1 flex md:justify-center">
                                <Award size={18} strokeWidth={1.25} className="text-ivory/60 group-hover:text-lime transition-colors" />
                            </div>
                            <div className="col-span-12 md:col-span-6">
                                <h3 className="font-serif-display text-2xl md:text-[1.75rem] leading-snug text-ivory group-hover:text-lime transition-colors">
                                    {a.title}
                                </h3>
                            </div>
                            <div className="col-span-12 md:col-span-4 md:text-right font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/55">
                                {a.by}
                            </div>
                        </motion.li>
                    ))}
                </ul>

                <div className="mt-20 md:mt-28">
                    <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime mb-8">
                        As featured in
                    </div>
                    <div className="flex flex-wrap gap-x-10 gap-y-6 items-center">
                        {PRESS.map((p, i) => (
                            <motion.div
                                key={p}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.7, ease: EASE, delay: i * 0.04 }}
                                data-testid={`press-${i}`}
                                className="font-serif-display italic text-2xl md:text-3xl text-ivory/70 hover:text-ivory transition-colors"
                            >
                                {p}
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
